import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import ArticleHeader from "./ArticleHeader";
import KeepReading from "./KeepReading";
import { SupplementalReferenceBox } from "./ReferenceBox";
import articles from "../../articles/_generated";
import { stripFrontmatter } from "../../common/format";

function Article(props) {
    const [content, setContent] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.title]);

    useEffect(() => {
        setContent(stripFrontmatter(articles[props.slug] || ""));
    }, [props.slug]);

    const components = {
        p: ({ node, ...rest }) => <p className="article-content" {...rest} />,
        // eslint-disable-next-line jsx-a11y/heading-has-content
        h1: ({ node, ...rest }) => <h1 className="article-content" {...rest} />,
        // eslint-disable-next-line jsx-a11y/heading-has-content
        h2: ({ node, ...rest }) => <h2 className="article-content" {...rest} />,
        // eslint-disable-next-line jsx-a11y/heading-has-content
        h3: ({ node, ...rest }) => <h3 className="article-content" {...rest} />,
        ul: ({ node, ...rest }) => <ul className="article-content" {...rest} />,
        ol: ({ node, ...rest }) => <ol className="article-content" {...rest} />,
        li: ({ node, ...rest }) => <li className="article-content" {...rest} />,
        blockquote: ({ node, ...rest }) => <blockquote className="article-content" {...rest} />,
        table: ({ node, ...rest }) => <table className="article-content" {...rest} />,
        tr: ({ node, ...rest }) => <tr className="article-content" {...rest} />,
        th: ({ node, ...rest }) => <th className="article-content" {...rest} />,
        td: ({ node, ...rest }) => <td className="article-content" {...rest} />,
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        a: ({ node, ...rest }) => <a className="inline-ref" target="_blank" rel="noreferrer" {...rest} />,
        // eslint-disable-next-line jsx-a11y/alt-text
        img: ({ node, ...rest }) => <img className="article-image" {...rest} />,
        hr: ({ node, ...rest }) => <hr className="section-break" {...rest} />,
    };

    return (
        <div className="article-content">
            <ArticleHeader slug={props.slug} title={props.title} topics={props.topics} date={props.date} />
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={components}>
                {content}
            </ReactMarkdown>
            <SupplementalReferenceBox references={props.references} />
            <KeepReading slug={props.slug} />
        </div>
    );
}

export default Article;
